// extracted by mini-css-extract-plugin
module.exports = {"container":"Ac","copy":"Bc","field":"Cc","error":"Dc","disabled":"Ec","termsContainer":"Fc","termsHeading":"Gc","termsCopy":"Hc","submit":"Ic","srOnly":"Jc"};